import React, { useState, memo, useEffect, useRef } from 'react';
import SignatureModal from './SignatureModal';

const SignatureField = ({ label, existingSignature, onSignatureSubmit, errorMessage, disabled, required, isshowUpdatebtn }) => {
    const [isModalOpen, setModalOpen] = useState(false);
    const [signaturePreview, setSignaturePreview] = useState(existingSignature || null);
    const sigCanvasRef = useRef();

    useEffect(() => {
        if (existingSignature && !isshowUpdatebtn) {
            setSignaturePreview(existingSignature);
        }

    }, [existingSignature]);

    useEffect(() => {
        if (label !== "SIGNATURE") {
            if (existingSignature && !isshowUpdatebtn) {
                setSignaturePreview(existingSignature);
            } else {
                setSignaturePreview(null);
            }
        }
        else if (existingSignature) {
            setSignaturePreview(existingSignature);
        }
    }, [isshowUpdatebtn]);

    const handleSignatureSubmit = (signatureDataURL) => {
        setSignaturePreview(signatureDataURL);
        onSignatureSubmit(signatureDataURL);
        setModalOpen(false);
    };

    return (
        <div className="form-group">
            <label className="form-label col-form-label w-100 fs-5">
                {label} {required && <span className="mandatory">*</span>}
            </label>
            <div>
                {signaturePreview ? (
                    <img
                        src={signaturePreview}
                        alt="Signature"
                        className={`form-control form-control-lg ${errorMessage ? 'border-danger' : ''}`}
                        style={{ height: '95px', cursor: 'pointer' }}
                        onClick={() => { !disabled && setModalOpen(true); sigCanvasRef.current.clear() }}  // Open modal for existing signature
                    />
                ) : (
                    <input
                        type="text"
                        readOnly
                        disabled={disabled}
                        className={`form-control ${errorMessage ? 'border-danger' : ''}`}
                        style={{ height: '95px', cursor: 'pointer', background: (label === "SIGNATURE" || label == '75. Witness Signature:') ? "#efefef" : "transparent" }}
                        // placeholder="Click to add a signature"
                        onClick={() => { setModalOpen(true); sigCanvasRef.current.clear() }}
                    />
                )}

                {/* {errorMessage && <div className="error-msg text-danger-new">{errorMessage}</div>} */}
            </div>

            <SignatureModal
                isOpen={isModalOpen}
                onClose={() => setModalOpen(false)}
                onSubmit={handleSignatureSubmit}
                sigCanvasRef={sigCanvasRef}
                existingSignature={signaturePreview}
            />
        </div>
    );
};

export default memo(SignatureField);
